import axios from 'axios';
import { Itinerary } from './types';
import { ACCESS_TOKEN, REFRESH_TOKEN } from "./constants";
import { apiRoutes } from './routes/routes';

const API_BASE_URL = process.env.REACT_APP_API_URL;


export async function fetchItinerary(prompt: string): Promise<Itinerary> {
  const res = await axios.post(`${API_BASE_URL}/api/generate-itinerary/`, {
    prompt,
  });
  return res.data;
}


const api = axios.create({
  baseURL: API_BASE_URL,
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem(ACCESS_TOKEN);
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Fonction pour rafraîchir le token
const refreshToken = async () => {
  try {
    const refresh = localStorage.getItem(REFRESH_TOKEN);
    if (!refresh) {
      throw new Error("No refresh token available");
    }

    const response = await axios.post(`${API_BASE_URL}${apiRoutes.refresh_token}`, {
      refresh: refresh,
    });

    const newAccessToken = response.data.access;
    localStorage.setItem(ACCESS_TOKEN, newAccessToken);

    return newAccessToken;
  } catch (error) {
    console.error("Erreur lors du rafraîchissement du token", error);
    return null;
  }
};

// Intercepteur pour gérer les erreurs 401 et rafraîchir le token
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      const newToken = await refreshToken();
      if (newToken) {
        originalRequest.headers.Authorization = `Bearer ${newToken}`;
        return api(originalRequest); // Relancer la requête avec le nouveau token
      } else {
        // Rediriger vers la page de connexion si le refresh échoue
        // window.location.href = "/login";
      }
    }

    return Promise.reject(error);
  }
);

export default api;
